import { capitalize } from 'lodash';
import moment from 'moment-timezone';
import { checkUserResourcePermissions } from 'sonata-static-storage/lib/helpers/user.helpers';
import { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

import type { IntlFormatters } from 'react-intl';
import type { SelectorOptionPropsInterface } from 'sonata-react-components';
import type { Pixel } from 'sonata-static-storage/lib/schemas/pixel/pixel.schema';

export function getPixelTypeOptions(
  user: UserInterface,
  roles: UserRoleInterface[],
  formatMessage: IntlFormatters['formatMessage']
): SelectorOptionPropsInterface[] {
  return [
    {
      id: 'conversion',
      label: formatMessage({
        defaultMessage: 'Conversion',
        id: 'pixel.type.conversion'
      })
    },
    {
      id: 'stay',
      label: formatMessage({
        defaultMessage: 'Permanence',
        id: 'pixel.type.permanence'
      })
    }
  ].filter(option => checkUserResourcePermissions(`${option.id}Pixel`, user, roles));
}

export function getPixelImplementationOptions(
  formatMessage: IntlFormatters['formatMessage']
): SelectorOptionPropsInterface[] {
  return [
    {
      id: 'image',
      label: formatMessage({
        defaultMessage: 'Image',
        id: 'pixel.implementation.image'
      })
    },
    {
      id: 'script',
      label: formatMessage({
        defaultMessage: 'Script',
        id: 'pixel.implementation.script'
      })
    }
  ];
}

export function getPixelPlacementOptions(
  type: Pixel['type'] | null,
  formatMessage: IntlFormatters['formatMessage']
): SelectorOptionPropsInterface[] {
  return [
    {
      id: 'visit',
      label: formatMessage({
        defaultMessage: 'Visit',
        id: 'pixel.placement.visit'
      })
    },
    {
      id: 'section',
      label: formatMessage({
        defaultMessage: 'Section',
        id: 'pixel.placement.section'
      })
    },
    ...(type === 'conversion'
      ? [
          {
            id: 'final',
            label: formatMessage({
              defaultMessage: 'Final',
              id: 'pixel.placement.final'
            })
          }
        ]
      : [])
  ];
}

export function pixelToRow(pixel: Pixel, linkCallback: (pixel: Pixel) => void, nameCallback: (pixel: Pixel) => void) {
  return {
    actions: [
      {
        icon: 'fa-solid fa-code',
        id: `pixel-view-${pixel._id}`,
        onClick: () => linkCallback(pixel),
        shape: 'link',
        size: 'ultraSmall',
        type: 'tertiary'
      },
      {
        icon: 'fal fa-pen-to-square',
        id: `row-edit-button-pixel${pixel._id}`,
        onClick: () => nameCallback(pixel),
        shape: 'link',
        size: 'ultraSmall',
        text: 'Edit'
      }
    ],
    campaigns: pixel.campaigns,
    creation: moment.utc(pixel.modified).format('DD/MM/YYYY - HH:mm'),
    id: pixel._id!,
    pixel,
    title: pixel.name,
    type: capitalize(pixel.type)
  };
}
